import Request from '@/api/request';

// 实现用户登录
export function login(params) {
  return Request('/entrance/login', {
    method: 'POST',
    data: params,
  });
}

// 实现用户登出
export function logout(params) {
  return Request('/entrance/logout', {
    method: 'GET',
    data: params,
  });
}
// // 获取用户菜单
// export function permissions(params) {
//   return Request('/admin_loan/user/permissions', {
//     method: 'GET',
//     data: params,
//   });
// }
// 获取用户信息
export function getUser(params) {
  return Request('/admin/info', {
    method: 'POST',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/login.api.js